<template>
  <OnexAlert class="mb-4" :type="Notifications.error" dismissible="false">
    {{ $t('L_your_policy_will_be_terminated', { date: formattedPaymentDueDate }) }}
  </OnexAlert>
</template>

<script lang="ts">
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import type { IPolicyStorePolicy } from '@/modules/policy/store/policyStore.model';
import { mapStores } from 'pinia';
import { defineComponent, type ComponentOptions } from 'vue';
import { Notifications, OnexAlert } from '@primerica/onex-ui-lib';
import { formatDate } from '@/shared/util/formatters.ts';

const componentOptions: ComponentOptions = {
  name: 'TermLifeCardYourPolicyWillBeTerminatedAlert',
  props: {
    indexPolicy: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  components: { OnexAlert },
  data() {
    return {
      Notifications,
    };
  },
  computed: {
    ...mapStores(usePolicyStore),
    selectedPolicy(): IPolicyStorePolicy {
      return this.policyStore.policies[this.indexPolicy];
    },
    formattedPaymentDueDate() {
      return formatDate(this.selectedPolicy?.nextPaymentDueDate, 'yyyy-MM-dd');
    },
  },
};

export default defineComponent(componentOptions);
</script>
